exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.handle {\n\tfont-size: 20px;\n}\n.active {\n\tbackground: #FDF7BF;\n\tborder: 1px dashed #E3CE00;\n}\n", ""]);

// exports
